(function (ws, global) {
    'use strict';
    /**
     * @typedef {Object} Event - DOM Event object
     */
    ws.views.savedCartDeleteModal = ws.views.modal.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'order_activity',
        GTM_EVENT_DELETE_ACTION: 'saved_cart_delete',

        events: _.extend({}, ws.views.modal.prototype.events, {
            'click .csc-delete-confirm-btn': 'deleteSavedCart'
        }),

        /**
         * Initialize
         */
        initialize: function () {
            ws.views.modal.prototype.initialize.call(this);
            this.$deleteConfirmBtn = this.$('.csc-delete-confirm-btn');
        },

        /**
         * deletes saved cart
         */
        deleteSavedCart: function() {
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_DELETE_ACTION);
            _satellite.track('event:DeleteSavedCart');
            this.model = new ws.models.savedCartDeleteModalModel();
            this.model.save({cartId: this.$('#cartId').val()}).done(function (data) {
                if (data) {
                    window.location.href = this.$deleteConfirmBtn.data('url');
                }
            }.bind(this));
        }
    });
})(westcon, window);
